import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { QuickReplyCategory } from "./types";

const CategorySelect: React.FC<{
  label?: string;
  categories: QuickReplyCategory[];
  value: string;
  onChange: (value: string) => void;
}> = ({ label, categories, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const selected = categories.find((c) => c.value === value);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative">
      {label && <label className="block text-sm font-semibold text-gray-800 dark:text-gray-200 mb-1.5">{label}</label>}
      <button
        type="button"
        onClick={() => setIsOpen((o) => !o)}
        className="w-full flex items-center justify-between border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 bg-white dark:bg-transparent text-left hover:border-gray-400 dark:hover:border-gray-500 transition-colors"
      >
        <span className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{selected?.label || "Select category"}</span>
          {selected?.description && <span className="text-xs text-[#7B7B7B] font-semibold dark:text-gray-500 truncate">{selected.description}</span>}
        </span>
        <ChevronDown size={18} className={`text-[#7B7B7B] font-semibold dark:text-gray-500 transition-transform shrink-0 ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <ul className="absolute z-20 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg py-1 max-h-56 overflow-y-auto">
          {categories.map((c) => (
            <li
              key={c.value}
              onClick={() => {
                onChange(c.value);
                setIsOpen(false);
              }}
              className="px-4 py-2.5 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
            >
              <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{c.label}</p>
              <p className="text-xs text-[#7B7B7B] font-semibold dark:text-gray-500">{c.description}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategorySelect;
